export default "__VITE_ASSET__URxXNKdK__"